import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import { SiNotion } from "react-icons/si";
import { BsGithub, BsGooglePlay, BsYoutube } from "react-icons/bs";
import { CgWebsite } from "react-icons/cg";
import IslandUrbanism from "../../Assets/Projects/island_urbanism.png";
import DealCheck from "../../Assets/Projects/dealcheck.png";
import ProceduralTerrainGenerator from "../../Assets/Projects/procedural_terrain_generator.png";
import StockSimulator from "../../Assets/Projects/stock_simulator.png";
import PiratenKapern from "../../Assets/Projects/piraten_kapern_logo.png";
import SolarSim from "../../Assets/Projects/solarsim.png";
import AmyBucketDisco from "../../Assets/Projects/amybucketdisco.png";
import FacialExpressions from "../../Assets/Projects/facialexpressions.png";
import DiningReview from "../../Assets/Projects/dining_review_api_logo.png";
import GetAGrip from "../../Assets/Projects/get_a_grip_logo.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Projects </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={DealCheck}
              isBlog={false}
              title="DealCheck"
              description="An system that helps user navigate the world of vehicle purchases, with the main feature of detecting deal quality through AI. The system also utilizes AI to recommending cars based on user specifications."
              buttons={[
                { logo: <BsGithub />, text: 'GitHub', link: 'https://github.com/AhsanM71/DealCheck' },
              ]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://play-lh.googleusercontent.com/eiVNy1LdQWMbZL7TMQDZbVzq0-SIOzJH2zSv4SUHUJgaf-ZnVSvpHnREM2iBRlalBQ=w240-h480-rw"
              isBlog={false}
              title="Vibes Music"
              description="An offline music player android app that allows users to enjoy their time listening to their favourite music."
              buttons={[
                { logo: <BsGithub />, text: 'GitHub', link: 'https://github.com/Sceptres/Vibes-Music-Android' },
                { logo: <BsGooglePlay />, text: 'Google Play Store', link: 'https://play.google.com/store/apps/details?id=com.aaa.vibesmusic' }
              ]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={StockSimulator}
              isBlog={false}
              title="Stock Trading Simulator"
              description="My team's submission to the HackVortex CodeStorm 4 hackathon. During this hackathon we were tasked to build a system that teaches people about a certain topic. We decided to build a web app that teaches people the basics of stock investing through content as well as experience."
              buttons={[
                { logo: <BsGithub />, text: 'GitHub', link: 'https://github.com/Sceptres/Hackathon' },
                { logo: <BsYoutube />, text: 'Youtube Video', link: 'https://www.youtube.com/watch?v=iakAoPKZCZ8' },
                { logo: <CgWebsite />, text: 'Live Demo', link: 'https://sceptres.github.io/Hackathon/' }
              ]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={IslandUrbanism}
              isBlog={false}
              title="Island Urbanism"
              description="An extension of the Procedural Terrain Generator project. This project adds an arbitrary number of cities, that is set by the user, to the islands and connects them using a star network."
              buttons={[
                { logo: <BsGithub />, text: 'GitHub', link: 'https://github.com/Sceptres/Island-Urbanism' }
              ]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ProceduralTerrainGenerator}
              isBlog={false}
              title="Procedural Terrain Generator"
              description="Led a team of 3 in developing a terrain generator that is highly customizable to achieve any specific terrain. Also has a seed system (similar to games like Minecraft) that allow users to regenerate the same island."
              buttons={[
                { logo: <BsGithub />, text: 'GitHub', link: 'https://github.com/Sceptres/Island-Generator' }
              ]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={DiningReview}
              isBlog={false}
              title="Dining Review API"
              description="An API that keeps track of users rating a restaurant's ability to handle different allergies. Currently includes peanut, egg, and dairy allergies. API has many endpoints to handle all ratings."
              buttons={[
                { logo: <BsGithub />, text: 'GitHub', link: 'https://github.com/Sceptres/dining_review_api' }
              ]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={PiratenKapern}
              isBlog={false}
              title="Piraten Kapern"
              description="A simulator of the Piraten Kapern board game. Has two algorithmic strategies, random and combo, combo is the superior strategy with 95% win rate agains random. It is a CMD program where all the results are logged on the CMD."
              buttons={[
                { logo: <BsGithub />, text: 'GitHub', link: 'https://github.com/Sceptres/Piraten-Kapern' }
              ]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={SolarSim}
              isBlog={false}
              title="SolarSim"
              description="A desktop app built in C++ using the OpenGL API that simulates a small solar system consisting of the Sun, Earth, and Moon."
              buttons={[
                { logo: <BsGithub />, text: 'GitHub', link: 'https://github.com/Sceptres/SolarSim' },
                { logo: <BsYoutube />, text: 'Youtube', link: 'https://www.youtube.com/watch?v=Rwsw86FiF3Q' }
              ]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={AmyBucketDisco}
              isBlog={false}
              title="Amy, Bucket, and Disco"
              description='A desktop app built in C++ using the OpenGL API that loads 3 meshes, "Amy", the bucket, and the floor and rotates 3 spotlights to act as disco lights.'
              buttons={[
                { logo: <BsGithub />, text: 'GitHub', link: 'https://github.com/Sceptres/AmyBasketDisco' },
                { logo: <BsYoutube />, text: 'Youtube', link: 'https://www.youtube.com/watch?v=lN7RMLmTI94' }
              ]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={FacialExpressions}
              isBlog={false}
              title="Facial Expressions"
              description="A desktop app built in C++ using the OpenGL API that loads and blends face meshes to create new faces."
              buttons={[
                { logo: <BsGithub />, text: 'GitHub', link: 'https://github.com/Sceptres/FacialExpressions' },
                { logo: <BsYoutube />, text: 'Youtube', link: 'https://www.youtube.com/watch?v=PqMpzIRZ5i4' }
              ]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={GetAGrip}
              isBlog={false}
              title="Get A Grip"
              description="Led a team of 3 in developing the software of a robotic arm. The robotic arm has the task of delivering a tool container to the sanitization bay based on its color."
              buttons={[
                { logo: <BsGithub />, text: 'GitHub', link: 'https://github.com/Sceptres/Get_A_Grip' },
                { logo: <SiNotion />, text: 'Notion', link: 'https://rough-popcorn-b16.notion.site/Get-A-Grip-2c5f974f0e7b495c89634f73c28cb0a1' }
              ]}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://play-lh.googleusercontent.com/tH_RmLwq1SDhnU-ntRPch89rgMcnvQUwHOA5bf2ABkVjmKXvLerVgAiiL6TpEg14YFI=w240-h480-rw"
              isBlog={false}
              title="Smart Grade Tracker"
              description="A reliable Android application that helps students keep track of their grades across multiple years. Each year is seperated allowing the students to look back at grades many years back."
              buttons={[
                { logo: <BsGithub />, text: 'GitHub', link: 'https://github.com/Sceptres/Smart_Grade_Tracker' },
                { logo: <BsGooglePlay />, text: 'Google Play Store', link: 'https://play.google.com/store/apps/details?id=com.aaa.schooltracker' }
              ]}
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
